export const USER_FACING_ERROR_KEYS = {
  GENERIC: 'generic',
  LOGIN_REQUIRED: 'login-required',
  RATE_LIMIT: 'rate-limit',
  MESSAGE_TOO_LONG: 'message-too-long',
  CONVERSATION_TURN_LIMIT: 'conversation-turn-limit',
  AGENT_ERROR: 'agent-error',
} as const

export type UserFacingAgentErrorKey = typeof USER_FACING_ERROR_KEYS[keyof typeof USER_FACING_ERROR_KEYS]

export interface BooksyAssistantErrorContext {
  operation: string
  status?: number
  responseBody?: string
  sessionId?: string | null
  userId?: string | number
  userMessage?: string
}
